import { styled } from '@mui/material';
import { Form } from 'formik';

export const StyledForm = styled(Form)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;
